export enum FlagStatus {
  Positive = 'positive',
  Negative = 'negative',
  InProgress = 'in_progress',
  OnHold = 'on_hold',
}
